import { Controller } from "@hotwired/stimulus";

// Model & Map workspace controller — owns URL state for the active file,
// step, and source column selectors so the operator can deep-link or
// reload without losing context. Also scrolls the source-columns table
// to a selected column when arriving via "?column=...".
export default class extends Controller {
  connect() {
    this.scrollToActiveColumn();
  }

  scrollToActiveColumn() {
    const params = new URLSearchParams(window.location.search);
    const column = params.get("column");
    if (!column) return;

    const escaped =
      typeof CSS !== "undefined" && typeof CSS.escape === "function"
        ? CSS.escape(column)
        : column.replace(/"/g, '\\"');
    const target = this.element.querySelector(
      `[data-test-id="model-and-map-row-${escaped}"]`
    ) as HTMLElement | null;
    target?.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  // Updates the URL `column` param without a full reload. Bound from
  // source-column row click handlers if needed in the future.
  selectColumn(event: Event) {
    const trigger = event.currentTarget as HTMLElement | null;
    const column = trigger?.dataset?.column;
    if (!column) return;

    const url = new URL(window.location.href);
    url.searchParams.set("column", column);
    window.history.replaceState({}, "", url.toString());
  }
}
